/**
 * undercover® FAQ (<uc-faq>): vloeiende hoogte-animatie voor <details>.
 * Zonder JS of bij reduced motion werkt <details> gewoon native.
 */
(() => {
  if (customElements.get('uc-faq')) return;
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  class UcFaq extends HTMLElement {
    connectedCallback() {
      this.onClick = (event) => {
        const summary = event.target.closest('summary');
        if (!summary || !this.contains(summary) || reduce.matches) return;
        const details = summary.parentElement;
        const panel = details.querySelector('.uc-faq__a');
        if (!panel || !panel.animate) return;
        event.preventDefault();
        this.toggle(details, panel, !details.open);
      };
      this.addEventListener('click', this.onClick);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
    }

    toggle(details, panel, open) {
      details._anim?.cancel();
      const opts = { duration: 360, easing: 'cubic-bezier(0.22, 1, 0.36, 1)' };
      if (open) {
        details.open = true;
        const end = panel.scrollHeight;
        details._anim = panel.animate({ height: ['0px', `${end}px`], opacity: [0, 1] }, opts);
      } else {
        const start = panel.offsetHeight;
        details._anim = panel.animate({ height: [`${start}px`, '0px'], opacity: [1, 0] }, { ...opts, duration: 280 });
        details._anim.onfinish = () => (details.open = false);
      }
      details._anim.oncancel = () => (details._anim = null);
    }
  }

  customElements.define('uc-faq', UcFaq);
})();
